import { LoadState } from "../../constants/enums";

export interface IMarketingState {
  marketingHistoryList: IMarketings[];
  totalRecords: number;
  marketHistoryListLoading: LoadState;
  marketing: IMarketings;
  marketingLoading: LoadState;
  marketingGroupedList: IGroupedMarketing[];
  marketingGroupedListLoading: LoadState;
}

export interface IGroupedMarketing extends IMarketings {
  childs: IMarketings[];
}

export interface IMarketings {
  policy_business_add_marketing_history_id: number;
  customer_policy_id: number;
  customer_id: number;
  serial_number: number;
  customer_name: string | null;
  quote_number: string | null;
  quote_status: string;
  premium: null;
  submission_date: string | null;
  date_received: string | null;
  insurer: string | null;
  underwriter: string | null;
  status: string;
  created_by_id: number;
  insert_ts: string;
  type: string;
}

export const initialMarketing: IMarketings = {
  policy_business_add_marketing_history_id: 0,
  customer_policy_id: 0,
  customer_id: 0,
  serial_number: 0,
  customer_name: null,
  quote_number: null,
  quote_status: "",
  premium: null,
  submission_date: null,
  date_received: null,
  insurer: null,
  underwriter: null,
  status: "",
  created_by_id: 0,
  insert_ts: "",
  type: "",
};

export const defaultMarketingsState: IMarketingState = {
  marketingHistoryList: [],
  totalRecords: 0,
  marketHistoryListLoading: LoadState.NotLoaded,
  marketing: initialMarketing,
  marketingLoading: LoadState.NotLoaded,
  marketingGroupedList: [],
  marketingGroupedListLoading: LoadState.NotLoaded,
};
